<template>
  <div v-if="table_permissions" class="v-datatable-shell h-100">
    <div class="v-datatable-scroll">
    <v-data-table
      v-model="selected"
      :fixed-header="true"
      light
      dense
      height="100%"
      show-select
      :single-select="disableSelectAllCheckbox"
      :items="items"
      :headers="headers"
      :sort-by.sync="orderBy"
      :sort-desc.sync="sortOrder"
      :items-per-page="itemPerPage"
      item-key="id"
      class="mx-2 mt-0 font-weight-bold"
      hide-default-footer
      @dblclick:row="showDetail"
      mobile-breakpoint="40"
    >
      <!--    no-data-->
      <template v-slot:no-data> {{ $t("datatable_no_data_here") }} </template>
      <template v-slot:no-results>
        {{ $t("datatable_no_results_here") }}
      </template>
      <!--    no-data end-->

      <template v-slot:top>
        <div
          class="ma-0 mb-10 pa-0 pt-2 d-flex justify-space-between align-center flex-wrap bg-white position-sticky top-0 zindex-5"
          :class="{ 'flex-column': $vuetify.breakpoint.xsOnly }"
        >
          <datatable-detail
            :table_properties="table_properties"
            v-if="$vuetify.breakpoint.smAndUp"
          ></datatable-detail>
          <div
            v-else
            class="d-flex align-center justify-space-between mb-3 w-100"
          >
            <datatable-detail
              :table_properties="table_properties"
            ></datatable-detail>
            <b-button
              v-show="$vuetify.breakpoint.xsOnly"
              depressed
              small
              variant="outline-primary"
              class="px-5 py-3 mb-1 btn--tools"
              @click="toolBarVisionState = !toolBarVisionState"
            >
              {{ $t("tools") }}
            </b-button>
          </div>

          <div
            v-show="isToolbarVisiable"
            style="display: flex; justify-content: center; align-items: center"
            class="card-toolbar ma-0 pa-0 col-md-8 col-sm-10 col-12 row justify-content-start justify-content-sm-end justify-content-md-end align-center align-content-center"
          >
            <div
              class="me-md-2 me-sm-1 mb-1 me-0 pa-0"
              :class="{ 'col-6 px-8 mt-3': $vuetify.breakpoint.xsOnly }"
              v-if="permissionChecker('assign_carrier')"
            >
              <button
                @click.prevent="assignCarrier"
                class="btn btn--export-filter me-3"
              >
                <span class="svg-icon">
                  <v-icon size="18">mdi-cart-plus</v-icon>
                </span>
                {{ $t("assign_carrier") }}
              </button>
              <button
                @click.prevent="showAddItemModal"
                class="btn btn--export-filter"
              >
                <span class="svg-icon">
                  <v-icon size="18">mdi-plus-box-outline</v-icon>
                </span>
                {{ $t("add") }} {{ table_properties.title }}
              </button>
              <AddItem
                :pageLoader="pageLoad"
                :refresher="updateTableContent"
                ref="addItem"
              ></AddItem>
            </div>
            <div
              class="me-md-2 me-sm-1 mb-1 me-0 pa-0"
              v-if="permissionChecker('update_pickup_status')"
            >
              <button
                class="btn btn--export-filter w-100"
                @click.prevent="() => updateStatus(null, true)"
              >
                <span class="svg-icon d-none d-sm-inline-block">
                  <v-icon size="18">mdi-refresh</v-icon>
                </span>
                {{ $t("update_status") }}
              </button>
              <ChangeStatus
                :refresher="updateTableContent"
                :pageLoader="pageLoad"
                ref="changeStatus"
                :ids="updateStatusItemId"
                :isMultiple="getIsUpdateStatusItemsMultiple"
              ></ChangeStatus>
            </div>
            <div
              class="me-md-2 me-sm-1 mb-1 me-0 pa-0"
              :class="{ 'col-6 mx-8': $vuetify.breakpoint.xsOnly }"
              v-if="permissionChecker('upload')"
            >
              <button
                class="btn btn--export-filter"
                @click.prevent="showUploadModal"
              >
                <span class="svg-icon">
                  <v-icon size="18">mdi-cloud-upload</v-icon>
                </span>
                {{ $t("import") }}
              </button>
            </div>
            <!--begin::Dropdown-->
            <div
              class="me-md-2 me-sm-1 mb-1 me-0 pa-0"
              :class="{ 'col-6 px-8 mt-3': $vuetify.breakpoint.xsOnly }"
              v-if="permissionChecker('export') && exportHeaders"
            >
              <button
                @click="$refs.exportSidebar.$data.exportSidebar = true"
                class="btn btn--export-filter"
              >
                <span class="svg-icon">
                  <v-icon size="18">mdi-export-variant</v-icon>
                </span>
                {{ $t("export") }}
              </button>
            </div>

            <!--end::Button-->

            <div
              class="me-md-2 me-sm-1 mb-1 me-0 pa-0"
              :class="{ 'col-6 px-8 mt-3': $vuetify.breakpoint.xsOnly }"
              v-if="filters.length > 0"
            >
              <button
                @click="$refs.filterSidebar.$data.filterSidebar = true"
                class="btn btn--export-filter"
              >
                <span class="svg-icon">
                  <v-icon size="18">mdi-filter</v-icon>
                </span>
                {{ $t("filter") }}
              </button>
            </div>
            <div
              v-if="showBulkActions"
              class="me-md-2 me-sm-1 mb-1 me-0 pa-0 mt-1"
            >
              <b-dropdown
                ref="action-dropdown"
                id="action-dropdown"
                :text="$t('actions')"
                class="me-3 mb-1 p-0 col-12"
                toggle-class="poppins btn btn--export-filter"
                menu-class="m-0 p-0 ms-n4"
                no-caret
                variant="upload"
              >
                <template v-slot:button-content>
                  <div class="px-2">
                    <span class="svg-icon">
                      <v-icon size="18">mdi-dns</v-icon>
                    </span>
                    <span>{{ $t("actions") }}</span>
                    <span class="svg-icon me-0 ms-2">
                      <v-icon size="18">mdi-chevron-down</v-icon>
                    </span>
                  </div>
                </template>
                <div class="q-status-menu py-1 w-175px">
                  <div
                    class="drop-item poppins px-3 mx-3 rounded-lg cursor-pointer"
                    @click="bulkAssignAwb"
                    v-if="permissionChecker('assign_awb')"
                  >
                    <div
                      class="py-2 w-100 text-start drop-text poppins font-size-sm font-weight-medium my-2"
                    >
                      {{ $t("assign_awb") }}
                    </div>
                  </div>
                  <div
                    class="drop-item poppins px-3 mx-3 rounded-lg cursor-pointer"
                    @click="bulkResetShipmentFlag"
                    v-if="permissionChecker('reset_shipment_flag')"
                  >
                    <div
                      class="py-2 w-100 text-start drop-text poppins font-size-sm font-weight-medium my-2"
                    >
                      {{ $t("reset_shipment_flag") }}
                    </div>
                  </div>
                  <div
                    class="drop-item poppins px-3 mx-3 rounded-lg cursor-pointer"
                    @click="bulkPickup3plStatusSync"
                    v-if="permissionChecker('pickup_3pl_status_sync')"
                  >
                    <div
                      class="py-2 w-100 text-start drop-text poppins font-size-sm font-weight-medium my-2"
                    >
                      {{ $t("pickup_3pl_status_sync") }}
                    </div>
                  </div>
                  <div
                    class="drop-item poppins px-3 mx-3 rounded-lg cursor-pointer"
                    @click="bulkPickupResetToAssigned"
                    v-if="permissionChecker('assign_carrier')"
                  >
                    <div
                      class="py-2 w-100 text-start drop-text poppins font-size-sm font-weight-medium my-2"
                    >
                      {{ $t("reset_to_assigned") }}
                    </div>
                  </div>
                </div>
              </b-dropdown>
            </div>

            <!--end::Button-->
          </div>
        </div>
        <!-- Export Sidebar start -->
        <ExportSidebar
          v-if="permissionChecker('export') && exportHeaders"
          ref="exportSidebar"
          :exportHeaders="exportHeaders"
          :downloadItem="downloadItem"
          :submitFilterValues="submitFilterValues"
          :resetFilterValues="resetFilterValues"
          :filters="filters"
          :setTableFiltersValues="setTableFiltersValues"
        />
        <!--        end::Export Sidebar-->

        <!-- Filter Sidebar start -->
        <FilterSidebar
          v-if="filters.length > 0"
          ref="filterSidebar"
          :submitFilterValues="submitFilterValues"
          :resetFilterValues="resetFilterValues"
          :filters="filters"
          :setTableFiltersValues="setTableFiltersValues"
        />
        <!--end::Filter Sidebar-->

        <Others ref="otherData"></Others>
      </template>

      <template
        v-if="!disableSelectAllCheckbox"
        v-slot:header.data-table-select="{ props: { value }, on: { input } }"
      >
        <div
          class="form-check form-check-sm form-check-custom form-check-solid me-5 min-w-20px min-h-20px"
        >
          <input
            class="form-check-input"
            type="checkbox"
            v-model="allSelected"
            @click="selectAll"
          />
        </div>
      </template>

      <template v-slot:item.data-table-select="{ item }">
        <div
          class="form-check form-check-sm form-check-custom form-check-solid me-5 min-w-20px min-h-20px"
        >
          <input
            class="form-check-input"
            type="checkbox"
            v-model="selected"
            @click="selectOne"
            :value="item"
          />
        </div>
      </template>
      <template
        v-for="(head, i) in headers"
        v-slot:[`item.`+head.value]="{ item, header, value }"
      >
        <ComponentSelector
          v-bind:key="i"
          :item="item"
          :header="header"
          :value="value"
          :module="'pickupOrders'"
        ></ComponentSelector>
      </template>

      <template #item.action="{ item }">
        <v-menu
          :left="!$vuetify.rtl"
          :right="$vuetify.rtl"
          transition="scale-transition"
          offset-y
          bottom
          rounded
        >
          <template v-slot:activator="{ on, attrs }">
            <a
              v-bind="attrs"
              v-on="on"
              class="btn btn-light-light btn-hover-info show poppins min-w-100px min-w-md-110px"
            >
              {{ $t("actions") }}
              <span class="svg-icon svg-icon-5 m-0">
                <v-icon small>mdi-chevron-down</v-icon>
              </span>
            </a>
          </template>
          <v-card class="poppins py-1" elevation="1">
            <div v-if="permissionChecker('update')">
              <v-btn
                class="w-100 text-start"
                :disabled="!item.extra_data.detail.actions.update"
                :class="
                  !item.extra_data.detail.actions.update
                    ? 'text-muted'
                    : 'text-dark'
                "
                @click="editItem(item)"
                text
                >{{ $t("edit") }}</v-btn
              >
            </div>

            <div v-if="permissionChecker('view')">
              <v-btn
                class="w-100 text-start"
                :disabled="!item.extra_data.detail.actions.show"
                :class="
                  !item.extra_data.detail.actions.show
                    ? 'text-muted'
                    : 'text-dark'
                "
                @click="() => showItemDetail(item)"
                text
                >{{ $t("view") }}</v-btn
              >
            </div>
            <div v-if="permissionChecker('pickup_cancel')">
              <v-btn
                class="w-100 text-start"
                :disabled="!item.extra_data.detail.actions.pickup_cancel"
                :class="
                  !item.extra_data.detail.actions.pickup_cancel
                    ? 'text-muted'
                    : 'text-dark'
                "
                @click="() => updateStatusAction(item)"
                text
                >{{ $t("cancel") }}</v-btn
              >
            </div>
            <div v-if="permissionChecker('destroy')">
              <v-btn
                class="w-100 text-start"
                :disabled="!item.extra_data.detail.actions.delete"
                :class="
                  !item.extra_data.detail.actions.delete
                    ? 'text-muted'
                    : 'text-dark'
                "
                @click="removeItem(item)"
                text
                >{{ $t("remove") }}</v-btn
              >
            </div>
          </v-card>
        </v-menu>
      </template>
      <!-- column end -->
    </v-data-table>
    </div>
    <div v-if="items.length" class="v-datatable-pagination-row">
      <Pagination
        :setitemPerPage="setitemPerPage"
        :getitemPerPage="getitemPerPage"
        :getpageNumber="getpageNumber"
        :setpageNumber="setpageNumber"
        :totalItems="totalItems"
        :pageCount="pageCount"
        :updateTableContent="updateTableContent"
      ></Pagination>
    </div>
    <EditItem
      :refresher="updateTableContent"
      :pageLoader="pageLoad"
      :itemForAction="getItemForAction"
      ref="editModal"
    ></EditItem>
    <AssignCarrier
      ref="assingCarrier"
      :items="selected"
      :updateTableContent="updateTableContent"
    ></AssignCarrier>
    <BulkAssignAwb
      ref="bulkAssignAwb"
      :items="selected"
      :updateTableContent="updateTableContent"
    />
  </div>
</template>

<script>
import {
  EXPORT_TABLE_DATA,
  SET_FILTERS_DATA,
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PERPAGE,
  SET_TABLE_SORTBY,
  SET_TABLE_SORTORDER,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
} from "@/core/services/store/pickupOrders.module";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import { SET_ITEM_FOR_ACTION } from "@/core/services/store/main.module";
import ComponentSelector from "@/own/components/datatable/ComponentSelector.vue";
import FilterSidebar from "@/own/components/sidebars/FilterSidebar.vue";
import ExportSidebar from "@/own/components/sidebars/ExportSidebar.vue";
import Others from "@/own/components/shipping/pickupOrders/Others.vue";
import AddItem from "@/own/components/shipping/pickupOrders/AddItem.vue";
import EditItem from "@/own/components/shipping/pickupOrders/EditItem";
import AssignCarrier from "@/own/components/shipping/pickupOrders/AssignCarrier.vue";
import BulkAssignAwb from "@/own/components/shipping/pickupOrders/BulkAssignAwb";

import Pagination from "@/own/components/pagination/Pagination.vue";
import Swal from "sweetalert2";
import DatatableDetail from "@/own/components/datatable/DatatableDetail";
import ApiService from "@/core/services/api.service";
import getPageWidthHeight from "@/own/mixins/getPageWidthHeight";
import ChangeStatus from "@/own/components/shipping/pickupOrders/ChangeStatus.vue";

export default {
  name: "DataTable",
  mixins: [getPageWidthHeight],
  components: {
    DatatableDetail,
    FilterSidebar,
    ExportSidebar,
    Pagination,
    Others,
    AddItem,
    EditItem,
    AssignCarrier,
    ComponentSelector,
    ChangeStatus,
    BulkAssignAwb,
  },
  props: {
    disableSelectAllCheckbox: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data: () => ({
    toolBarVisionState: false,
    selected: [],
    offset: true,
    columnsModal: false,
    allSelected: false,
    itemForAction: null,
    updateStatusItemId: null,
    isUpdateStatusItemsMultiple: true,
  }),
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.$store.dispatch(UPDATE_TABLE_STRUCTURE, {}).then(() => {});
    this.$store.dispatch(UPDATE_TABLE_DATA, {}).then(() => {});
  },
  beforeCreate() {
    this.$store.commit(SET_PAGE_LOADING, true);
  },
  beforeDestroy() {
    if (typeof window === "undefined") return;

    window.removeEventListener("resize", this.onResize, { passive: true });
  },
  mounted() {
    this.onResize();

    window.addEventListener("resize", this.onResize, { passive: true });
  },
  computed: {
    showBulkActions: function () {
      const bulkActions = [
        "assign_awb",
        "reset_shipment_flag",
        "pickup_3pl_status_sync",
        "pickup_reset_to_assigned",
      ];

      if (this.table_permissions.length) {
        return this.table_permissions.some((permission) =>
          bulkActions.includes(permission)
        );
      }
      return false;
    },
    getIsUpdateStatusItemsMultiple() {
      return this.isUpdateStatusItemsMultiple;
    },
    getItemForAction() {
      return this.itemForAction;
    },
    isToolbarVisiable: function () {
      return this.$vuetify.breakpoint.smAndUp ? true : this.toolBarVisionState;
    },
    //pagination
    getitemPerPage: function () {
      return this.$store.getters.getPICKUPORDERSTableState.per_page;
    },
    getpageNumber: function () {
      return this.$store.getters.getPICKUPORDERSTableState.page;
    },
    totalItems: function () {
      return this.$store.getters.getPICKUPORDERSTableData.total;
    },
    pageCount: function () {
      return this.$store.getters.getPICKUPORDERSTableData.last_page;
    },
    //filters
    filters: function () {
      let filters = null;
      try {
        filters = this.$store.getters.getPICKUPORDERSTableFilters;
      } catch {
        filters = [];
      }
      return filters;
    },
    table_permissions: function () {
      if (this.$store.getters.getPICKUPORDERSTablePermissions) {
        return this.$store.getters.getPICKUPORDERSTablePermissions.map(
          function (perm) {
            return perm.name;
          }
        );
      } else {
        return false;
      }
    },
    table_properties: function () {
      return this.$store.getters.getPICKUPORDERSTableProperties;
    },
    itemPerPage: function () {
      return this.$store.getters.getPICKUPORDERSTableState.per_page;
    },
    orderBy: {
      get: function () {
        return this.$store.getters.getPICKUPORDERSTableState.sortBy;
      },
      set: function (newValue) {
        if (newValue) {
          this.$store.commit(SET_TABLE_SORTBY, newValue);
          this.$store.dispatch(
            UPDATE_TABLE_DATA,
            this.$store.getters.getPICKUPORDERSTableState
          );
        } else {
          this.$store.commit(SET_TABLE_SORTBY, "");
          this.$store.dispatch(
            UPDATE_TABLE_DATA,
            this.$store.getters.getPICKUPORDERSTableState
          );
        }
      },
    },
    sortOrder: {
      get: function () {
        let sortOrder = true;
        if (this.$store.getters.getPICKUPORDERSTableState.sortOrder === "asc") {
          sortOrder = false;
        }
        return sortOrder;
      },
      set: function (newValue) {
        if (newValue === true) {
          this.$store.commit(SET_TABLE_SORTORDER, "desc");
        } else {
          this.$store.commit(SET_TABLE_SORTORDER, "asc");
        }
        this.$store.dispatch(
          UPDATE_TABLE_DATA,
          this.$store.getters.getPICKUPORDERSTableState
        );
      },
    },
    headers: function () {
      let headers = this.$store.getters.getPICKUPORDERSTableHeaders.filter(
        (col) => col.visible === true
      );
      headers.forEach((header) => {
        header.class =
          "text-muted fw-bolder font-size-sm text-uppercase poppins-ls";
        header.itemClass = "second-text";
        header.width = undefined;
        if (header.value === "action") {
          header.class =
            "pe-10 text-end text-muted fw-bolder font-size-sm text-uppercase poppins-ls";
        }
      });
      return headers;
    },
    exportHeaders: function () {
      // let headers = this.$store.getters.getPICKUPORDERSTableHeaders.filter(
      //   (col) => col.exportable == true
      // );
      // return headers;
      let headers = null;
      try {
        headers = this.$store.getters.getPICKUPORDERSTablePermissions
          .find((col) => col.name === "export")
          ?.columns.sort((a, b) => a.order - b.order);
      } catch {
        headers = null;
      }

      return headers;
    },
    items: function () {
      if (this.$store.getters.getPICKUPORDERSTableData) {
        return this.$store.getters.getPICKUPORDERSTableData.data;
      }
      return [];
    },
    hasSelected: function () {
      return this.selected.length > 0;
    },
  },
  methods: {
    bulkAssignAwb() {
      if (!this.selected.length) {
        Swal.fire({
          title: this.$t("no_order_selected"),
          text: this.$t("select_orders_to_assign_carrier"),
          icon: "warning",
          showConfirmButton: true,
        });
        return;
      }
      this.$refs.bulkAssignAwb.toggleModal();
    },
    bulkResetShipmentFlag() {
      if (!this.selected.length) {
        Swal.fire({
          title: this.$t("no_order_selected"),
          text: this.$t("select_orders_to_reset_shipment_flag"),
          icon: "warning",
          showConfirmButton: true,
        });
        return;
      }
      this.pageLoad(true);
      const ids = this.selected.map((item) => item.id);
      ApiService.post("/shipping/pickup_orders/reset_shipment_flag", { ids })
        .then(() => {
          Swal.fire({
            title: this.$t("notificationtitle_success"),
            text: this.$t("shipment_flag_reset_successfully"),
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          this.updateTableContent();
        })
        .catch(() => {
          this.pageLoad(false);
        });
    },
    bulkPickup3plStatusSync() {
      if (!this.selected.length) {
        Swal.fire({
          title: this.$t("no_order_selected"),
          text: this.$t("select_orders_to_sync_3pl_status"),
          icon: "warning",
          showConfirmButton: true,
        });
        return;
      }
      this.pageLoad(true);
      const ids = this.selected.map((item) => item.id);
      ApiService.post("/shipping/pickup_orders/pickup_3pl_status_sync", { ids })
        .then(() => {
          Swal.fire({
            title: this.$t("notificationtitle_success"),
            text: this.$t("status_sync_completed_successfully"),
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          this.updateTableContent();
        })
        .catch(() => {
          this.pageLoad(false);
        });
    },
    bulkPickupResetToAssigned() {
      if (!this.selected.length) {
        Swal.fire({
          title: this.$t("no_order_selected"),
          text: this.$t("select_orders_to_reset_to_assigned"),
          icon: "warning",
          showConfirmButton: true,
        });
        return;
      }
      this.pageLoad(true);
      const ids = this.selected.map((item) => item.id);
      ApiService.post("/shipping/pickup_orders/pickup_reset_to_assigned", {
        ids,
      })
        .then(() => {
          Swal.fire({
            title: this.$t("notificationtitle_success"),
            text: this.$t("pickup_reset_to_assigned_successfully"),
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          this.updateTableContent();
        })
        .catch(() => {
          this.pageLoad(false);
        });
    },
    updateStatus(item = null, is_multiple = false) {
      if (this.selected.length === 0) {
        Swal.fire({
          title: this.$t("warning"),
          text: this.$t("select_at_least_one_order"),
          icon: "warning",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      if (is_multiple) {
        if (this.selected.length === 1) {
          this.updateStatusItemId = this.selected[0].id;
          this.isUpdateStatusItemsMultiple = false;
        } else {
          this.updateStatusItemId = this.selected.map((item) => item.id);
          this.isUpdateStatusItemsMultiple = true;
        }
      } else {
        this.updateStatusItemId = item.id;
        this.isUpdateStatusItemsMultiple = false;
      }
      this.$nextTick(() => {
        this.$refs.changeStatus.toggleModal();
      });
    },
    updateStatusAction(item) {
      this.pageLoad(true);
      ApiService.post(`/shipping/pickup_orders/status`, { id: item.id })
        .then(() => {
          Swal.fire({
            title: this.$t("canceled"),
            text: this.$t("pickup_order_canceled_successfully"),
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          this.updateTableContent();
        })
        .catch(() => {
          this.pageLoad(false);
        });
    },
    removeItem(item) {
      Swal.fire({
        title: this.$t("notificationtitle_are_you_sure"),
        text: this.$t("notificationmessage_you_wont_be_able_to_revert_this"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: this.$t("cancel"),
        confirmButtonText: this.$t("notificationmessage_yes_delete_it"),
      }).then((result) => {
        if (result.isConfirmed) {
          this.pageLoad(true);
          //TODO: change data sending to id
          const data = { id: item.id };
          ApiService.post(`/shipping/pickup_orders/destroy`, data)
            .then(() => {
              Swal.fire(
                this.$t("notificationtitle_deleted"),
                this.$t("record_has_been_deleted"),
                "success"
              );
              this.updateTableContent();
            })
            .catch(() => {
              this.pageLoad(false);
            });
        }
      });
    },
    deleteAllItems() {
      this.selected.splice(0, this.selected.length);
      this.allSelected = false;
    },
    selectOne(event) {
      this.allSelected && this.deleteItem(event.target.value);

      this.allSelected = false;
    },
    selectAll(event) {
      this.deleteAllItems();
      if (event.target.checked) {
        this.items.forEach((item) => {
          this.selected.push(item);
        });
      }
    },
    onResize() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.toolBarVisionState = false;
      } else if (this.$vuetify.breakpoint.mdAndUp) {
        this.toolBarVisionState = true;
      }
    },
    handle_function_call(function_name, prop) {
      this[function_name](prop);
    },
    editItem(item) {
      if (!item.extra_data.detail.actions.update) {
        return;
      }
      this.$store.commit(SET_ITEM_FOR_ACTION, item);
      this.itemForAction = item.id;
      this.$nextTick(() => {
        this.$refs.editModal.toggleModal();
      });
    },
    // pagination
    setitemPerPage(val) {
      this.$store.commit(SET_TABLE_PERPAGE, val);
      this.$store.commit(SET_TABLE_PAGE, 1);
      this.deleteAllItems();
    },
    setpageNumber(val) {
      this.$store.commit(SET_TABLE_PAGE, val);
      this.deleteAllItems();
    },
    // pagination end
    // filters
    setTableFiltersValues(val) {
      this.$store.commit(SET_TABLE_FILTER, val);
    },
    showUploadModal() {
      this.$router.push({
        name: "settings.uploads",
        query: { type: this.$store.getters.getPICKUPORDERSUploadType },
      });
    },
    submitFilterValues() {
      this.$store.commit(SET_PAGE_LOADING, true);
      let state = { ...this.$store.getters.getPICKUPORDERSTableState };
      state.page = 1;
      this.$store
        .dispatch(UPDATE_TABLE_DATA, state)
        .then(() => {
          this.$store.commit(SET_TABLE_PAGE, 1);
          this.$store.commit(SET_PAGE_LOADING, false);
        })
        .catch((res) => {
          this.$store.commit(SET_PAGE_LOADING, false);
          Swal.fire({
            title: "",
            text: `${res}`,
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
      this.$store.commit(SET_FILTERS_DATA, this.men);
    },
    resetFilterValues() {
      this.$store.commit(SET_PAGE_LOADING, true);
      this.men = [];
      this.queryObj = {};
      // this.$refs.filterSidebar.$refs.filter.clearFiltersState();

      this.$store.commit(SET_TABLE_FILTER, []);
      this.$store
        .dispatch(
          UPDATE_TABLE_DATA,
          this.$store.getters.getPICKUPORDERSTableState
        )
        .then(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    // filters end
    /**
     * checks permission and return true/false
     * @types {boolean}
     * example "view","create","update","destroy","show","generate","status","print","activate","upload"
     **/
    permissionChecker(permType) {
      return !!this.table_permissions.includes(permType);
    },
    // isAnyFilterSelected() {
    //   let isSelected = false;
    //   if (this.$store.getters.getPICKUPORDERSTableState.filters.length > 0) {
    //     isSelected = true;
    //   }
    //   return isSelected;
    // },
    // exports
    downloadItem(columns) {
      // if (!this.isAnyFilterSelected()) {
      //   this.$refs.exportSidebar.$data.exportSidebar = false;
      //   Swal.fire({
      //     title: "Warning",
      //     text: "Please, select at least one filter!",
      //     icon: "warning",
      //     showConfirmButton: false,
      //     timer: 2500,
      //   });
      //   this.export_modal = false;
      //   return;
      // }
      this.$store.commit(SET_PAGE_LOADING, true);
      this.export_modal = false;
      this.$store
        .dispatch(EXPORT_TABLE_DATA, {
          columns: columns,
          filters: this.$store.getters.getPICKUPORDERSTableState.filters,
        })
        .then(() => {
          const link = document.createElement("a");
          link.href = this.$store.getters.getPICKUPORDERSExportUrl;
          link.download = "Export.csv";
          link.click();
          setTimeout(() => {
            this.$store.commit(SET_PAGE_LOADING, false);
          }, 1500);
          this.$refs.exportSidebar.$refs.export.toggleModal();
        });
    },
    // exports end
    showItemDetail(item) {
      this.loadDetailData(item.id);
    },
    showDetail(val, { item }) {
      this.loadDetailData(item.id);
    },
    loadDetailData(id) {
      this.$store.commit(SET_PAGE_LOADING, true);
      let data = { id: id };
      ApiService.post("/shipping/pickup_orders/show", data)
        .then((response) => {
          this.$store.commit(SET_PAGE_LOADING, false);
          // this.$refs.otherData.$props.isLoaded = true;
          // this.$refs.otherData.$props.other = response.data.asn;
          this.$refs.otherData.setData(response.data.pickup_order);
          this.$refs.otherData.toggleModal();
        })
        .catch(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    pageLoad(state) {
      this.$store.commit(SET_PAGE_LOADING, state);
    },
    showAddItemModal() {
      this.$refs.addItem.toggleModal();
    },
    assignCarrier() {
      if (!this.selected.length) {
        Swal.fire({
          title: this.$t("no_order_selected"),
          text: this.$t("select_orders_to_assign_carrier"),
          icon: "warning",
          showConfirmButton: true,
        });
        return;
      }
      this.$refs.assingCarrier.toggleModal();
    },
    async updateTableContent() {
      this.pageLoad(true);
      await this.$store
        .dispatch(
          UPDATE_TABLE_DATA,
          this.$store.getters.getPICKUPORDERSTableState
        )
        .then(() => {
          this.selected = [];
        });
      this.$forceUpdate();
      this.pageLoad(false);
    },
  },
};
</script>
